import React from 'react';
import { Table } from 'reactstrap';

import TableRenderer from './TableRenderer';
import { ConfigItem } from './types';

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  config: ConfigItem[];
};

/*
----------------------------------
DetailModal Component
----------------------------------
This is a generic component to render the detail modal
It takes the following props:
1. data: data to be rendered in the table
2. config: config for the table
----------------------------------
*/
const DetailTable = ({ data, config }: Props) => {
  return data &&
    ((typeof data === 'object' && Object.keys(data).length) || data.length) ? (
    <Table className="tablesorter table-striped" responsive>
      <tbody>
        <TableRenderer data={data} config={config} />
      </tbody>
    </Table>
  ) : (
    <div className="d-flex h-100 justify-content-center">
      <p>We&apos;re syncing data. Check back in a few minutes.</p>
    </div>
  );
};

export default DetailTable;
